// realtime/subscriptions/usePendingCashierSalesSubscription.ts

import { useEffect, useRef } from 'react';

import { useDispatch } from 'react-redux';

import { socketClient } from '../socketClient';

import { subscribeWhenConnected } from '../utils/subscribeWhenConnected';

import { PendingCashierSaleRealtimeMessage } from '../../types/websocket/PendingCashierSaleRealtimeMessage';

import { triggerPendingCashierRefresh } from '../../store/slices/sale/saleSlice';

interface Props {
    enabled: boolean;
}

export const usePendingCashierSalesSubscription = ({
    enabled,
}: Props) => {

    const dispatch = useDispatch();

    const subscribedRef = useRef(false);

    const subscriptionRef = useRef<any>(null);

    useEffect(() => {

        if (!enabled) {

            subscriptionRef.current?.unsubscribe();

            subscribedRef.current = false;

            return;
        }

        if (subscribedRef.current) {
            return;
        }

        subscribeWhenConnected(() => {

            if (subscribedRef.current) {
                return;
            }

            subscribedRef.current = true;

            subscriptionRef.current =
                socketClient.subscribe(

                    '/topic/sales/pending-cashier',

                    (message) => {

                        if (!message.body) {
                            return;
                        }

                        try {

                            const payload:
                                PendingCashierSaleRealtimeMessage =
                                JSON.parse(message.body);

                            console.log(
                                '💵 Pending cashier realtime:',
                                payload
                            );

                            dispatch(
                                triggerPendingCashierRefresh()
                            );

                        } catch (error) {

                            console.error(
                                '❌ Error pending cashier realtime:',
                                error
                            );
                        }
                    }
                );

            console.log(
                '✅ Subscription Pending Cashier registrada'
            );
        });

        return () => {

            subscriptionRef.current?.unsubscribe();

            subscriptionRef.current = null;

            subscribedRef.current = false;

            console.log(
                '🛑 Subscription Pending Cashier removida'
            );
        };

    }, [enabled]);
};